import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-publishing-mode-required-modal',
  standalone: false,
  templateUrl: './publishing-mode-required-modal.component.html',
  styleUrl: './publishing-mode-required-modal.component.scss',
})
export class PublishingModeRequiredModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  constructor(
    private router: Router
  ) {
    
  }
  
  onClose() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }

  onGoToPublishingMode(): void {
    this.onClose();

    this.router.navigate(
      ['/settings'],
      {
        queryParams: {
          tab: 'subscription'
        }
      }
    );
  }
}
